import cx from 'classnames';
import type { FC } from 'react';

import type { Optional } from '@zen/utils/typescript';

export interface Props {
  className?: string;
  hasPlatformAccess: boolean;
  imageUrl?: string;
  name?: string;
  size?: 'small' | 'normal';
}

const getFirstChar = (name: Optional<string>) => name && name[0].toUpperCase();

const Avatar: FC<Props> = (props) => {
  const { className, hasPlatformAccess, imageUrl, name, size = 'normal' } = props;

  const imagePresent: boolean = !!imageUrl;

  const classNames: string = cx(
    'relative flex justify-center items-center rounded-full text-white border',
    {
      'w-8 h-8 text-sm': size === 'normal',
      'w-6 h-6 text-xs': size === 'small',
      'bg-grey-dark border-solid border-grey-dark': hasPlatformAccess && !imagePresent,
      'bg-white border-dashed border-grey-base': !hasPlatformAccess && !imagePresent,
      'border-transparent': imagePresent
    },
    className
  );

  return (
    <div className={classNames} data-testid="avatar">
      {imagePresent && <img alt={name} className="w-auto h-full rounded-full" src={imageUrl} />}
      {!imagePresent && getFirstChar(name)}
    </div>
  );
};

export type { Props as AvatarProps };

export default Avatar;
